var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('m-edit-text',{attrs:{"label":_vm.label,"value":_vm.pretty,"custom_on_edit":_vm.onClickEdit,"read_only":_vm.read_only,"hint":_vm.hint,"show_hint_everywhere":""}}),_c('m-edit-wall-time-dialog',{ref:"edit-dialog",attrs:{"title":_vm.label,"value":_vm.value,"optional":_vm.optional},on:{"ok":function($event){return _vm.onSet($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }